import React from "react";
import { Plus, Trash } from "@phosphor-icons/react";
import { Section, Field, Tick, INPUT } from "./obUi";

const BLANK = { name: "", case_tag: "", quote: "", stars: 5 };

const Row = ({ t, i, onChange, onRemove, ro }) => (
  <div className="sm:col-span-2 border-2 border-zinc-300 p-4 grid grid-cols-1 sm:grid-cols-3 gap-3" data-testid={`ob-testimonial-${i}`}>
    <input className={INPUT} placeholder="Client name, e.g. Maria G." value={t.name} disabled={ro}
           onChange={(e) => onChange({ ...t, name: e.target.value })} data-testid={`ob-testimonial-${i}-name`} />
    <input className={INPUT} placeholder="Case type, e.g. Car accident" value={t.case_tag} disabled={ro}
           onChange={(e) => onChange({ ...t, case_tag: e.target.value })} data-testid={`ob-testimonial-${i}-case`} />
    <select className={INPUT} value={t.stars} disabled={ro} onChange={(e) => onChange({ ...t, stars: Number(e.target.value) })}
            data-testid={`ob-testimonial-${i}-stars`}>
      {[5, 4, 3, 2, 1].map((s) => <option key={s} value={s}>{s} star{s > 1 ? "s" : ""}</option>)}
    </select>
    <textarea className={`${INPUT} sm:col-span-3`} rows={2} placeholder="What they said (at least 20 characters)" value={t.quote}
              disabled={ro} onChange={(e) => onChange({ ...t, quote: e.target.value })} data-testid={`ob-testimonial-${i}-quote`} />
    {!ro && (
      <button type="button" onClick={onRemove} className="sm:col-span-3 justify-self-start inline-flex items-center gap-1 text-[11px] uppercase tracking-widest text-red-700 hover:underline"
              data-testid={`ob-testimonial-${i}-remove`}><Trash size={12} weight="bold" /> Remove</button>
    )}
  </div>
);

export const TestimonialsSection = ({ a, set, ro }) => {
  const list = a.testimonials || [];
  const put = (next) => set("testimonials", next);
  return (
    <Section n={6} title="Client testimonials" testId="ob-section-testimonials"
             hint="Optional. Add up to 3 real client reviews to show on your pages. Our team checks them before they go up.">
      {list.map((t, i) => (
        <Row key={i} t={t} i={i} ro={ro} onChange={(v) => put(list.map((x, j) => (j === i ? v : x)))}
             onRemove={() => put(list.filter((_, j) => j !== i))} />
      ))}
      {!ro && list.length < 3 && (
        <Field wide label="">
          <button type="button" onClick={() => put([...list, { ...BLANK }])} data-testid="ob-testimonial-add"
                  className="inline-flex items-center gap-2 border-2 border-black px-3 py-2 text-[11px] uppercase tracking-widest hover:bg-zinc-100 transition-colors duration-100">
            <Plus size={12} weight="bold" /> Add a testimonial
          </button>
        </Field>
      )}
      {list.length > 0 && (
        <Field wide label="">
          <Tick ro={ro} checked={a.testimonial_consent} onChange={(v) => set("testimonial_consent", v)} testId="ob-testimonial-consent">
            These are real clients who agreed to have their words shared.
          </Tick>
        </Field>
      )}
    </Section>
  );
};
